import { getLang, getTranslations } from "../translations";
import { VehicleData } from "../types";
import { formatCurrency } from "./format";

export const getEVIncentives = (vehicle: VehicleData) => {
  const lang = getLang();
  const { labels } = getTranslations(lang);
  const costs = vehicle?.pcs?.en?.additional_prices;
  if (costs?.hasOwnProperty("federal_electric_incentive") && costs.hasOwnProperty("provincial_electric_incentive")) {
    return {
      total: formatCurrency(Number(costs.federal_electric_incentive.value_with_taxes) * -1 + Number(costs.provincial_electric_incentive.value_with_taxes) * -1, false, lang),
      count: 2,
      label: labels.ev_tag
    };
  }

  if (vehicle?.pcs?.en?.additional_prices.hasOwnProperty("federal_electric_incentive")) {
    return {
      total: formatCurrency(Number(costs.federal_electric_incentive.value_with_taxes) * -1, false, lang),
      count: 1,
      label: labels.ev_tag_federal_only
    };
  }

  if (vehicle?.pcs?.en?.additional_prices.hasOwnProperty("provincial_electric_incentive")) {

    return {
      total: formatCurrency(Number(costs.provincial_electric_incentive.value_with_taxes) * -1, false, lang),
      count: 1,
      label: labels.ev_tag_provincial_only
    };
  }

  return {
    count: 0
  };
};
